import React, { useEffect, useState } from 'react'
import { analytics } from 'Modules/Analytics'
import { initiatives } from 'Modules/Analytics/trackActionInterface/Impact/Initiatives'
import { useAppState } from 'Context/AppContext/AppContext'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import { ChartCalculationOptionsEnum } from '../types'

type ChartCalculationSelectorProps = {
  calculationType: string
  onChange: (type: ChartCalculationOptionsEnum) => void
}

export const ChartCalculationSelector = ({
  calculationType,
  onChange,
}: ChartCalculationSelectorProps) => {
  const {
    nonprofitOrgConfig: { role, nonprofitOrgRole },
  } = useAppState()
  const formattedCalculationType =
    calculationType.charAt(0).toUpperCase() +
    calculationType.slice(1).toLowerCase()

  const [calculation, setCalculation] = useState(formattedCalculationType)

  useEffect(() => {
    setCalculation(formattedCalculationType)
  }, [formattedCalculationType])

  const handleChartCalculationChange = (value: ChartCalculationOptionsEnum) => {
    onChange(value)
    analytics.trackActionCreator(
      initiatives.Goal_Chart_Chart_Calculation_Selected
    )({
      chartCalculation: value,
      role,
      relationship: nonprofitOrgRole,
    })
  }

  return (
    <FormControl>
      <InputLabel id='progressChartSelectorInputSelectChartCalculationLabel'>
        Show Values
      </InputLabel>
      <Select
        labelId='progressChartSelectorInputSelectChartCalculationLabel'
        id='progressChartSelectorInputSelectChartCalculation'
        value={calculation}
        onChange={(event) =>
          handleChartCalculationChange(
            event.target.value as ChartCalculationOptionsEnum
          )
        }
        required
        sx={{ height: '40px', minWidth: '120px' }}
      >
        <MenuItem value={ChartCalculationOptionsEnum.cumulative}>
          {ChartCalculationOptionsEnum.cumulative}
        </MenuItem>
        <MenuItem value={ChartCalculationOptionsEnum.incremental}>
          {ChartCalculationOptionsEnum.incremental}
        </MenuItem>
      </Select>
    </FormControl>
  )
}
